import { ArrowDown, ArrowUp } from '@chain-zen/ui'
import React from 'react'

import type { TStopAppointment } from '../../types/appointment'
import type { TStopType } from '../../types/post'
import { Appointment } from './appointment'
import { CityState } from './city-state'

interface OriginOrDestinationProps {
  appointment: TStopAppointment | null
  city: string | null
  fontSize?: string
  state: string | null
  type: TStopType
}

/**
 * Displays the origin destination pair
 */
export const OriginOrDestination = (props: OriginOrDestinationProps) => {
  const { appointment, city, state, type, fontSize } = props

  return (
    <div className="flex gap-1">
      {type === 'Pick' ? <ArrowUp className="h-4 w-4 mt-0.5" /> : <ArrowDown className="h-4 w-4 mt-0.5" />}
      <div className="flex flex-col space-y-1">
        <CityState city={city} state={state} fontSize={fontSize} />
        {appointment ? <Appointment appointment={appointment} /> : <span className="text-sm">Appointment Pending</span>}
      </div>
    </div>
  )
}

interface OriginDestinationPairProps {
  destinationAppointment: TStopAppointment | null
  destinationCity: string | null
  destinationState: string | null
  originAppointment: TStopAppointment | null
  originCity: string | null
  originState: string | null
}

/**
 * Displays the origin and destination to display on the table
 */
export const OriginDestinationPair = (props: OriginDestinationPairProps) => {
  const { destinationAppointment, destinationCity, destinationState, originAppointment, originCity, originState } =
    props

  return (
    <div className="flex flex-col md:flex-row gap-4 items-start flex-1">
      <div className="flex w-full md:w-1/2">
        <OriginOrDestination appointment={originAppointment} city={originCity} state={originState} type="Pick" />
      </div>
      <div className="flex w-full md:w-1/2">
        <OriginOrDestination
          appointment={destinationAppointment}
          city={destinationCity}
          state={destinationState}
          type="Drop"
        />
      </div>
    </div>
  )
}
